// extracted by mini-css-extract-plugin
module.exports = {"root":"OccasionField_root__MsVJi"};